import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  constructor(
    private spinner: NgxSpinnerService
  ) { }

  show() : any {
    this.spinner.show();
  }

  hide() : any {
    this.spinner.hide();
  }

}
